import { frontendURL } from '../../../helper/URLHelper';
import MetaCampaignsDashboard from './pages/MetaCampaignsDashboard.vue';
import MetaCampaignsCampaignDetail from './pages/MetaCampaignsCampaignDetail.vue';

const commonMeta = {
  permissions: ['administrator'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/meta-campaigns'),
    name: 'meta_campaigns_dashboard',
    component: MetaCampaignsDashboard,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/meta-campaigns/:campaignId'),
    name: 'meta_campaigns_campaign_detail',
    component: MetaCampaignsCampaignDetail,
    meta: commonMeta,
  },
];
